import React from 'react'
import { Container, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import isAuthenticated from '../../../routes/PrivateRoute'

const Landing = ({ healthSystem, user }) => {
  return (
    <>
      {
        user.role && (
          <Container fluid className='configurator'>
            {
              user.role.roleId === 1 && (
                <Col xs={12}>
                  <h3 className='slate-gray'>{healthSystem.name}</h3>
                </Col>
              )
            }
            <Col xs={12} className='mt-3'>
              <h5>1. <Link to={`/health-system/${healthSystem.tenant}/actions`}>Actions</Link></h5>
            </Col>
            <Col xs={12} className='mt-3'>
              <h5>2. <Link to={`/health-system/${healthSystem.tenant}/rules`}>Rules</Link></h5>
            </Col>
            {
              user.role.roleId === 1 && (
                <Col xs={12} className='mt-3'>
                  <h5>3. <Link to={`/health-system/${healthSystem.tenant}/users`}>Users</Link></h5>
                </Col>
              )
            }
            {
              user.role.roleId === 1 && (
                <Col xs={12} className='mt-3'>
                  <h5>4. <Link to={`/health-system/${healthSystem.tenant}/reports`}>Reports</Link></h5>
                </Col>
              )
            }
          </Container>
        )
      }
    </>
  )
}

Landing.propTypes = {
  healthSystem: PropTypes.shape({
    healthSystemId: PropTypes.number,
    name: PropTypes.string,
    tenant: PropTypes.string,
    active: PropTypes.number,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
  }),
  user:  PropTypes.shape({
    userId: PropTypes.number,
    email: PropTypes.string,
    status: PropTypes.string,
    role: PropTypes.any
  }),
}

export default isAuthenticated(Landing)
